import { ClubFee } from '../club/club-fees';
import { Tournament } from '../club/club-tournament.model';
import { Practice } from '../practices/practices.model';
import { User } from '../user/user.model';

export interface PlayerEventResponse {
  eventId: string;
  response: number;
  eventType: number | string | undefined;
}
export interface PlayerResponse {
  player: PlayerInfo;
  response: number;
}

export interface PracticeDetailsResponse {
  practice: Practice;
  playerResponses: PlayerResponse[];
}

export interface PlayerInfo {
  id: string;
  isMVP: boolean;
  gender: string | null;
  profilePicture: string | null;
  dateOfBirth: string | null;
  user: User;
  phoneNumber: string;
  emergencyContacts: EmergencyContacts[];
  cricketProfile?: CricketProfile;
  sasUri: string;
  playerClubTournaments?: PlayerClubTournament[] | null;
  playerClubPayments?: playerClubPayments[] | null;
  expenses?: any[];
  transactions?: PlayerTransaction[];
  netDuesAmount?: number;
  displayNetDues?: string;
  hasOutstandingDues?: boolean;
  playerId?: string;
  userId?: string;
  playerEventResponse: PlayerEventResponse[];
  firstName?: string;
  lastName?: string;
  response?: number;
  eventType?: number;
  clubUser?: ClubUser;
}

export interface PlayerTransaction {
  id: string;
  name: string;
  type: TransactionType;
  typeDisplay: string;
  amount: number;
  displayAmount: string;
  amountDue?: number | null;
  displayAmountDue?: string | null;
  date: Date;
  notes?: string;
  clubFeeId?: string;
  feeType: number;
  clubFeeName?: string;
}

export enum TransactionType {
  Payment = 0,
  Expense = 1
}

export interface PlayerClubTournament {
  clubTournament: Tournament;
  players?: PlayerInfo;
}

export interface CricketProfile {
  battingStyle: number;
  battingOrder: number;
  bowlingStyle: number;
  bowlingOrder: number;
  playingRole: number;
  isWicketKeeper: boolean;
}

export interface EmergencyContacts {
  id: string;
  address: string;
  email: string;
  name: string;
  phoneNumber: string;
  relationship: string;
}

export interface playerClubPayments {
  id: string;
  amountPaid: number;
  displayAmountPaid?: string;
  paymentDate: string | null;
  paymentNotes: string;
  isActive: boolean;
  clubFee: ClubFee;
}

export interface PlayerDetailsForm {
  isChecked: boolean;
  badge: string;
  profilePicture: string;
  sasUri: string;
  fullName: string;
  response: number;
  player: PlayerResponse;
  isDropdownOpen: boolean;
  userId: string;
  captainUserId: string;
  vcUserId: string;
  wicketKeeperId: string;
}

export interface ClubUser {
  id: string;
  userId: string;
  clubId: string;
  user: User;
  role: number;
  isActive: boolean;
  isPending: boolean;
  createdAt: string;
  sasUri: string | null;
}

